import React from "react"

import Image from "./Image"

const PymeItem = ({ node }) => (
  <div className="text-center mx-auto mb-4">
    {node !== undefined && node.url !== undefined && (
      <>
        <a
          href={`${node.url}?utm_source=navidadpyme&utm_medium=banner&utm_campaign=navidadpyme_dic_2020&utm_term=homepage&utm_content=launch_week`}
          target="_blank"
          rel="noopener noreferrer"
          title={node.description}
        >
          <Image
            url={node.logo}
            alt={node.name}
            width={150}
            className="mb-4 block"
          />
          <p className="mx-auto" style={{ maxWidth: "16ch" }}>
            {node.name}
          </p>
          <p
            className="text-xs mx-auto text-gray-500 block h-8"
            style={{ maxWidth: "20ch" }}
          >
            {node && node.category && node.category.toUpperCase()}
          </p>
        </a>
      </>
    )}
  </div>
)

export default PymeItem
